@if (attachments?.length) {
    <div class="pt-24 w-100" fxLayout="column" fxLayoutAlign="start start">
        <af-file-group-preview [attachments]="attachments"
                          [showDownloadAll]="true"
                          spinnerId="downloadAllFiles"/>
    </div>
} @else {
    <ui-kit-empty-state class="mt-24 w-100"
                        icon="ic_empty_state_no_data"
                        [title]="'i18n_af_emptyStateTitleNoData'"
                        subtitle="i18n_af_emptyStateSubtitleNoData"
                        backgroundColor="dark"/>
}
